// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25328
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25328 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Return_Details: 'Return_Details'
})

interface IPVTrackParamsRecord {
  /** 退货详情页 */
Return_Details: undefined
}

const sendPv = {
  /** PV-退货详情页 */
Return_Details: () => {
    eventTrackingUtils.submitPV({page_id:PageId.Return_Details});
  },
}

interface IExpoTrackParamsRecord {
  /** 退货状态曝光 */
Return_Details_Status_Expo: {
/** 退货状态  */
returnStatus: string,
/** 订单id  */
orderId: string,
/** 服务单id  */
service_id: string}
  /** 取消申请按钮曝光 */
Return_Details_Cancel_Expo: {
/** 退货状态  */
returnStatus: string,
/** 订单id  */
orderId: string,
/** 服务单id  */
service_id: string}
  /** 退货商品项曝光 */
Return_Details_Sku_Expo: {
/** 退货状态  */
returnStatus: string,
/** 订单id  */
orderId: string,
/** 服务单id  */
service_id: string,
/** 商品id  */
skuid: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 退货状态曝光 */
  Return_Details_Status_Expo:'Return_Details_Status_Expo',
/** 取消申请按钮曝光 */
  Return_Details_Cancel_Expo:'Return_Details_Cancel_Expo',
/** 退货商品项曝光 */
  Return_Details_Sku_Expo:'Return_Details_Sku_Expo',
})

interface IClickTrackParamsRecord {
  /** 取消申请按钮点击 */
Return_Details_Cancel: {
/** 退货状态  */
returnStatus: string,
/** 订单id  */
orderId: string,
/** 服务单id  */
service_id: string}
}

const sendClickTrack = {
  /** 点击事件上报-取消申请按钮点击 */
Return_Details_Cancel: (json_param: IClickTrackParamsRecord['Return_Details_Cancel']) => {
    eventTrackingUtils.submitCL({event_id:'Return_Details_Cancel',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}